import type React from 'react';

import Box from '@mui/material/Box';
import { useMatches } from 'react-router';

import { BackgroundBranding } from '@/layouts/BackgroundBranding.comp.tsx';
import { LayoutShell } from '@/routes/LayoutShell.comp.tsx';
import { routesUtil } from '@/views/routes/utils/routes.util.ts';

/**
 * Bare layout group (OCD-308): no sidebar/topbar. Login paints transparent
 * chrome + always-visible branding; assessment detail paints the black
 * fullscreen backdrop. The scroll container marker stays so OCD-301
 * restoration works without a window scroll.
 */
export const BareLayout: React.FC = () => {
  const matches = useMatches();
  const bareVariant = routesUtil.resolveBareVariant(matches);
  const isLogin = bareVariant === 'login';
  const isAssessment = bareVariant === 'assessment';

  return (
    <>
      {isAssessment ? (
        <Box
          sx={{
            backgroundColor: 'black',
            inset: 0,
            pointerEvents: 'none',
            position: 'fixed',
            zIndex: 0,
          }}
        />
      ) : (
        <BackgroundBranding alwaysVisible={isLogin} />
      )}
      <LayoutShell isLoginView={isLogin} />
    </>
  );
};
